export default "__VITE_ASSET__BM9mw3bg__"